// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__7996R","spinner":"Loading_spinner__LtoCP"};